import {
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Stack,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

export default function ScenarioSelect({ options, value, onChange, onAdd, onRename }) {
  const handleChange = (event) => {
    const newValue = event.target.value;
    if (newValue === 'add') onAdd();
    else onChange(newValue);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%', pb: 2 }}>
      <FormControl fullWidth>
        <InputLabel id="scenario-select-label">Scenario</InputLabel>
        <Select
          labelId="scenario-select-label"
          id="scenario-select"
          value={value ?? { id: 'default', name: 'Base Case' }}
          label="Scenario"
          onChange={handleChange}
        >
          {!options?.some((e) => e.id === 'default') && (
            <MenuItem value="default">Base Case</MenuItem>
          )}

          {options?.map((e) => (
            <MenuItem value={e.id} key={e.id}>
              {e.name ?? 'Base Case'}
            </MenuItem>
          ))}

          <Divider />
          <MenuItem value="add">Add Scenario</MenuItem>
        </Select>
      </FormControl>
      <IconButton
        onClick={() => onRename(value)}
        size="medium"
        sx={{ height: '56px', aspectRatio: 1 }}
      >
        <EditIcon />
      </IconButton>
    </Stack>
  );
}
